import { useQuery } from 'common/hooks';
import { UseQueryOptions } from 'common/types/Api.type';
import { getMySkillEndorsementApi } from '../services';

export type MySkillEndorsement = {
  id: string;
  rating: number;
  endorsementDate: string;
};

export type MySkillEndorsementResponse = {
  data: {
    endorsement: MySkillEndorsement | null;
  };
};

export type MySkillEndorsementContext = MySkillEndorsementResponse['data'];

export const useGetMySkillEndorsement = (
  endorseeId: string,
  skillId: string,
  options: UseQueryOptions = {},
) => {
  const queryKey = ['my-skill-endorsement', endorseeId, skillId];
  const response = useQuery(
    queryKey,
    () => getMySkillEndorsementApi(endorseeId, skillId),
    {
      showErrorSnackbar: false,
      select: (result) => result.data as MySkillEndorsementContext,
      ...options,
    },
  );

  return {
    ...response,
    data: response.data as MySkillEndorsementContext | undefined,
  };
};
